import amplitude from 'amplitude-js';

const keys = {
  production: 'b2d6e37cf3d7d47ee2a50be7e1d29cec',
  staging: '9ff42464c29111a9a4586e2792e8375a',
  development: '13bb435405674380b8fe7b7739432d3f'
};

const EXPERIMENTS_SCRIPT_ID = 'amplitude-experiments-script';

export default class AmplitudeIntegration {
  static integrationName = 'amplitude';
  static enabled = true;
  static ready = false;
  static retry = 0;
  static experimentsLoaded = false;

  static emit(fn, params) {
    this[fn](params);
  }

  static setup() {
    if (this.ready) {
      return true;
    }

    amplitude.getInstance().init(keys[RAILS_ENV], null, {
      includeUtm: true,
      includeGclid: true,
      includeFbclid: true,
      saveParamsReferrerOncePerSession: true,
      logAttributionCapturedEvent: true
    });

    this.identify();
    this.loadExperiments();
    this.ready = true;
    return true;
  }

  static loadExperiments() {
    if (
      this.experimentsLoaded ||
      document.getElementById(EXPERIMENTS_SCRIPT_ID)
    ) {
      this.experimentsLoaded = true;
      return;
    }

    const apiKey = keys[RAILS_ENV];

    if (!apiKey) {
      return;
    }

    const script = document.createElement('script');
    script.id = EXPERIMENTS_SCRIPT_ID;
    script.src = `https://cdn.amplitude.com/script/${apiKey}.experiment.js`;
    script.async = true;

    document.head.appendChild(script);
    this.experimentsLoaded = true;
  }

  static identify(extraParams = {}) {
    const {
      id,
      name,
      email,
      created_at,
      subscription,
      subscriptionExpireAt,
      segment,
      previousExperience,
      carrers,
      source_project,
      daysRemaining,
      totalDaysRemaining,
      daysSinceExpiration,
      lastSubscriptionLevel,
      recurrence,
      lastSubscriptionDuration,
      institution,
      jobPost,
      recurrenceSystem,
      recurrenceStatus,
      haveQcCourse,
      courseExpired,
      qcCourseExpiration,
      qcCourses,
      sequenceOfDays,
      longestSequenceOfDays,
      isEnrolled
    } = this.getUserData();

    const experiments = this.getExperiments();

    const identify = new amplitude.Identify();

    if (id) {
      identify
        .set('name', name)
        .set('email', email)
        .setOnce('created_at', created_at)
        .set('subscription', subscription)
        .set('subscription expire at', subscriptionExpireAt)
        .set('segment', segment)
        .set('previous experience', previousExperience)
        .set('carrers', carrers)
        .set('source_project', source_project)
        .set('days remaining', daysRemaining)
        .set('total days remaining', totalDaysRemaining)
        .set('days since expiration', daysSinceExpiration)
        .set('last subscription level', lastSubscriptionLevel)
        .set('recurrence', recurrence)
        .set('last subscription duration', lastSubscriptionDuration)
        .set('institution', institution)
        .set('job_post', jobPost)
        .set('recurrence system', recurrenceSystem)
        .set('recurrence status', recurrenceStatus)
        .set('have qc course', haveQcCourse)
        .set('course expired', courseExpired)
        .set('qc course expiration', qcCourseExpiration)
        .set('qc courses', qcCourses)
        .set('study streak days', sequenceOfDays)
        .set('maximum streak days', longestSequenceOfDays)
        .set('is enrolled', isEnrolled);

      amplitude.getInstance().setUserId(id);
    }

    Object.entries(extraParams).forEach(([key, val]) => {
      identify.set(key, val);
    });

    experiments?.forEach(experiment => {
      identify.set(`experiment_${experiment.identifier}`, experiment.group);
    });

    amplitude.getInstance().identify(identify);
  }

  static getUserData() {
    const user = $('#js-current-user').get(0);

    if (!user) {
      return { id: null };
    }

    const {
      id,
      name,
      email,
      created_at,
      subscriptionStatus,
      subscriptionExpireAt,
      segment,
      previousExperience,
      carrers,
      daysRemaining,
      totalDaysRemaining,
      daysSinceExpiration,
      lastSubscriptionLevel,
      recurrence,
      lastSubscriptionDuration,
      institution,
      jobPost,
      recurrenceSystem,
      recurrenceStatus,
      haveQcCourse,
      courseExpired,
      qcCourseExpiration,
      qcCourses,
      sequenceOfDays,
      longestSequenceOfDays,
      isEnrolled
    } = user.dataset;

    return {
      id,
      name,
      email,
      created_at,
      subscription: subscriptionStatus,
      subscriptionExpireAt,
      segment,
      previousExperience,
      carrers,
      source_project: gon.source_project,
      daysRemaining,
      totalDaysRemaining,
      daysSinceExpiration,
      lastSubscriptionLevel,
      recurrence: recurrence === 'active',
      lastSubscriptionDuration,
      institution,
      jobPost,
      recurrenceSystem,
      recurrenceStatus,
      haveQcCourse,
      courseExpired,
      qcCourseExpiration,
      qcCourses,
      sequenceOfDays,
      longestSequenceOfDays,
      isEnrolled
    };
  }

  static getExperiments() {
    return gon.experiments;
  }

  static event({ eventName = 'default_1', data = {} }) {
    this.send(eventName, {
      ...data,
      source_project: gon.source_project
    });
  }

  static pageVisited({ pageName = 'default_2', data = {} }) {
    this.send(`${pageName} visited`, data);
  }

  static builderPageVisited({
    pageName = 'default_4',
    campaignType = 'Generic',
    data = {}
  }) {
    this.send('builder page visited', {
      campaign: pageName,
      'campaign type': campaignType,
      ...data
    });
  }

  static productInteraction() {
    // We are preventing this event at this time { product_id = 0, event_type = 'view', data = {} }
    return;
    // this.send('Product visited', { product_id, event_type, ...data });
  }

  static send(key, params) {
    this.identify();
    amplitude.getInstance().logEvent(key, params);
  }
}
